import { updateObject } from "../../helpers/common/utility";
import * as actionTypes from "../actions/types";

const initialState = {
  rencana_kontrol: [],
  farmasi: [],
  laboratorium: [],
  radiologi: [],
  history_pre_pasien: {
    data: [],
    total_page: 0,
    total_data: 0,
  },
};

const setRencanaKontrol = (state, action) => {
  return updateObject(state, {
    rencana_kontrol: action.data,
  });
};

const setFarmasi = (state, action) => {
  return updateObject(state, {
    farmasi: action.data,
  });
};

const setLaboratorium = (state, action) => {
  return updateObject(state, {
    laboratorium: action.data,
  });
};

const setRadiologi = (state, action) => {
  return updateObject(state, {
    radiologi: action.data,
  });
};

const setHistoryPrePatient = (state, action) => {
  return updateObject(state, {
    history_pre_pasien: {
      data: action.data.docs,
      total_page: action.data.pages,
      total_data: action.data.total,
    },
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_HISTORY_RENCANA_KONTROL:
      return setRencanaKontrol(state, action);
    case actionTypes.SET_HISTORY_FARMASI:
      return setFarmasi(state, action);
    case actionTypes.SET_HISTORY_LABORATORIUM:
      return setLaboratorium(state, action);
    case actionTypes.SET_HISTORY_RADIOLOGI:
      return setRadiologi(state, action);
    case actionTypes.SET_HISTORY_PRE_PATIENT:
      return setHistoryPrePatient(state, action);
    default:
      return state;
  }
};

export default reducer;
